import React, { useContext, useEffect, useState } from 'react';
import TrendingListingsContext from './TrendingListings.context';
import utils from 'utils';
import useSiteInitializedState from 'hooks/useSiteInitializedState';
import { LISTING_TIERS, TrendingListing } from 'models/Listing';
import api from 'api';
import { FIRST_PAGE } from 'data/global';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

const TrendingListings: React.FC = (props) => {
  const { children } = props;

  const [loading, setLoading] = useState(utils.isSSGHuman());

  const [trendings, setTrendings] =
    useSiteInitializedState<Array<TrendingListing>>('trendings-array');

  const { popServerError } = useContext(PopNotificationsContext);

  useEffect(() => {
    !utils.isSSGHuman() &&
      (async () => {
        try {
          setLoading(true);

          const {
            data: { items },
          } = await api.listings.getListings({
            page: FIRST_PAGE,
            limit: '25',
            tier: { $ne: LISTING_TIERS.PLATINUM },
          });

          setTrendings(items);
        } catch (e) {
          popServerError(e);
        } finally {
          setLoading(false);
        }
      })();
  }, [popServerError, setTrendings]);

  return (
    <TrendingListingsContext.Provider value={{ loading, trendings }}>
      {children}
    </TrendingListingsContext.Provider>
  );
};

export default TrendingListings;
